import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export interface PoolReadyToRunItem {
  PoolID: number
  ReadyToRun: boolean
}

export default function PoolReadyToRunUpdateObservable(list: PoolReadyToRunItem[]): Observable<string> {
  const params: string = JSON.stringify({ ReadyToRunList: list })
  return ObservableFromFetch<string>("RandomTest/UpdatePoolReadyToRun", params)
}
